import React from "react";

const SkyliftSkeleton = ({ showNav = false }) => {
  return (
    <>
      {showNav && (
        <nav className="block fixed top-0 right-0 left-0 z-20 md:relative border-b-0.6 border-secondary-lighten-300">
          <div className={`shimmer h-16 `}></div>
        </nav>
      )}
      <div className="mx-5 min-h-screen sm:mx-8 md:grid-cols-8 md:mx-16 lg:grid-cols-12 lg:gap-6 3xl:mx-32 lg:mx-18">
        <section className="flex flex-col justify-between max-w-5xl md:px-10 lg:flex-row lg:px-0 lg:mx-auto xl:max-w-7xl my-11.5 xl:w-272">
          <section className="w-full lg:w-7/12">
            <section className="flex flex-col w-full">
              <div className={`shimmer h-32 rounded`}></div>
              <section
                className={`shimmer my-6 h-60 w-full rounded-xl md:h-96`}
              ></section>
              <section
                className={`shimmer h-10 pt-3 flex flex-col mt-0 w-full`}
              ></section>
            </section>
          </section>
          <section className="relative w-full lg:pl-9 lg:mt-0 lg:w-2/5 3xl:pl-0 3xl:w-4/12 z-2 mt-18 xl:pl-18">
            <section
              className={`shimmer sticky top-20 mx-auto max-w-xl rounded-xl p-4 sm:p-8 h-104`}
            ></section>
          </section>
        </section>
      </div>
    </>
  );
};

export default SkyliftSkeleton;
